export default "__VITE_ASSET__NiUtj4pp__"